import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBooking } from '../context/BookingContext';
import { mockAirports } from '../utils/mockData';
import styles from './Landing.module.css';

interface FormData {
  from: string;
  to: string;
  departure: string;
  return: string;
}

export default function Landing() {
  const navigate = useNavigate();
  const { dispatch } = useBooking();

  const [formData, setFormData] = useState<FormData>({
    from: '',
    to: '',
    departure: '',
    return: '',
  });

  const handleInputChange = (field: keyof FormData, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.from || !formData.to || !formData.departure) {
      alert('Please fill in all required fields');
      return;
    }

    dispatch({
      type: 'SET_SEARCH_CRITERIA',
      payload: {
        from: formData.from,
        to: formData.to,
        departure: formData.departure,
        return: formData.return || undefined,
      },
    });

    navigate('/search');
  };

  const today = new Date().toISOString().split('T')[0];

  return (
    <div>
      <header style={{
        background: 'white',
        padding: 'var(--spacing-4) 0',
        boxShadow: 'var(--shadow)'
      }}>
        <div className="container">
          <h1 style={{
            fontSize: 'var(--font-size-xl)',
            fontWeight: '700',
            color: 'var(--primary-color)'
          }}>
            FlightBooker
          </h1>
        </div>
      </header>

      <section className={styles.hero}>
        <h1>Find Your Perfect Flight</h1>
        <p>
          Search and compare flights from top airlines around the world.
          Your journey begins with just a few clicks.
        </p>
      </section>

      <section className={styles.searchSection}>
        <form onSubmit={handleSubmit} className={styles.searchForm}>
          <div className={styles.formGroup}>
            <label htmlFor="from">From</label>
            <select
              id="from"
              value={formData.from}
              onChange={(e) => handleInputChange('from', e.target.value)}
              required
            >
              <option value="">Select departure</option>
              {mockAirports.map((airport) => (
                <option key={airport.code} value={airport.code}>
                  {airport.code} - {airport.city}
                </option>
              ))}
            </select>
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="to">To</label>
            <select
              id="to"
              value={formData.to}
              onChange={(e) => handleInputChange('to', e.target.value)}
              required
            >
              <option value="">Select destination</option>
              {mockAirports
                .filter(airport => airport.code !== formData.from)
                .map((airport) => (
                  <option key={airport.code} value={airport.code}>
                    {airport.code} - {airport.city}
                  </option>
                ))}
            </select>
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="departure">Departure</label>
            <input
              type="date"
              id="departure"
              value={formData.departure}
              onChange={(e) => handleInputChange('departure', e.target.value)}
              min={today}
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="return">Return (Optional)</label>
            <input
              type="date"
              id="return"
              value={formData.return}
              onChange={(e) => handleInputChange('return', e.target.value)}
              min={formData.departure || today}
            />
          </div>

          <div className={styles.formGroup}>
            <button type="submit" className={styles.searchButton}>
              Search Flights
            </button>
          </div>
        </form>
      </section>
    </div>
  );
}